import * as Sentry from '@sentry/react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { OverlayProvider } from 'react-aria';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { authStore } from './store/AuthStore';
import { history } from './history';

import { MotionConfig } from 'framer-motion';
import isValidProp from '@emotion/is-prop-valid';

import { GlobalStyles } from './theme/Global';

import { GlobalOverlayContextProvider } from './components/overlay/GlobalOverlayContextProvider';
import { LocaleProvider } from './providers/LocaleProvider';
import { LayoutContextProvider } from './LayoutContext';
import { NavContextProvider } from './containers/NavContext';
import { ContextMenuContextProvider } from './components/common/context-menu/ContextMenuContextProvider';

import { App } from './App';

import { currentOS, OS } from './lib/platform';
import { classes } from './theme/classes';

import { MobilePage } from './mobile/MobilePage';
import { AppContainer } from './AppContainer';

if (import.meta.env.MODE === 'production' && import.meta.env.PROD === true) {
  Sentry.init({
    dsn: 'https://57677201cd54491aa453cabe89f30c0b@o4504916257931264.ingest.sentry.io/4504949401387008',
    release: 'homey-web-app@' + import.meta.env.VITE_VERSION,
    ignoreErrors: [],
    beforeSend(event, hint) {
      // return null;
      return event;
    },
    // debug: true,
  });
}

const continueDesktopVersion = localStorage.getItem('continueDesktopVersion') === 'true';

const url = new URL(window.location.href);
const code = url.searchParams.get('code');
const state = url.searchParams.get('state');

if (code && state) {
  async function handleAuthentication() {
    if (code && state) {
      try {
        await authStore.authenticateWithAuthorizationCode(code);
        console.log('Redirecting to', state);
        window.location.href = state;
      } catch (err) {
        window.alert(err);
      }
    }
  }

  handleAuthentication();
} else if ((currentOS === OS.IOS || currentOS === OS.ANDROID) && continueDesktopVersion === false) {
  render(
    <OverlayProvider className={classes.overlayProvider}>
      {/* <GlobalStyles /> */}
      <MobilePage />
    </OverlayProvider>,
    document.getElementById('root')
  );
} else {
  render(
    <LocaleProvider>
      <AppContainer>
        {/** https://github.com/framer/motion/issues/1406 */}
        <MotionConfig isValidProp={isValidProp}>
          <OverlayProvider className={classes.overlayProvider}>
            <GlobalOverlayContextProvider>
              <Router history={history}>
                <DndProvider backend={HTML5Backend}>
                  <ContextMenuContextProvider>
                    <LayoutContextProvider>
                      <NavContextProvider>
                        <GlobalStyles />
                        <App />
                      </NavContextProvider>
                    </LayoutContextProvider>
                  </ContextMenuContextProvider>
                </DndProvider>
              </Router>
            </GlobalOverlayContextProvider>
          </OverlayProvider>
        </MotionConfig>
      </AppContainer>
    </LocaleProvider>,
    document.getElementById('root')
  );
}
